import ContentRotatorProps, { TItem } from "./contentRotator.types";

import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import getAlign from "../../../adapters/getAlign";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";

const contentRotatorAdapter = (data: any): ContentRotatorProps => {
  return {
    title: data?.tituloGeneral,
    cmsTitle: data?.titulo,
    align: getAlign(data?.alineacion),
    btnText: data?.tituloBoton,
    btnLink: data?.redireccionBoton,
    items: data?.referenciaPlantillaContenido?.map(
      (element): TItem => {
        return {
          imgUrl: element.imagenPrincipal[0].gatsbyImageData,
          title: element.tituloBanner,
          description: element.descripcion?.descripcion
            ? documentToReactComponents(
                JSON.parse(element?.descripcion?.descripcion)
              )
            : "",
          btnText: element.tituloBoton,
          btnLink: element.redireccionBoton,
          gtm: `gtmRedDeAmor-${normalizeTwoWords(
            element.tituloBanner
          )}-${normalizeTwoWords(element.tituloBoton)}`,
        };
      }
    ),
  };
};

export default contentRotatorAdapter;
